import React,{Component} from 'react'
import moment from 'moment'; 
import 'moment/locale/zh-cn'; 
import {ConfigProvider,Tooltip,DatePicker,Upload,Spin} from 'antd';
import zhCN from 'antd/es/locale/zh_CN'; 
import 'moment/locale/zh-cn';
import Header from '../common/checkHeader.jsx';
import Footer from '../common/checkFooter.jsx';
import {messageTips} from '../../common/service/Tools.jsx';
import {config} from '../../common/service/http'
import {getCookie} from '../../common/service/common'
moment.locale('zh-cn');
const textNumber = <div className="numberBox">
    <div className="numberTitle"><i className="icon ills"></i>字数计算说明</div>
    <div className="numberItem">格式规范的声明、目录、脚注、参考文献、致谢等内容，系统可智能识别；</div>
    <div className="numberItem">被识别后不会参与查重，系统仅依据其划分检测段落及判断引用情况；</div>
    <div className="numberItem">致谢部分，会作为正文参与查重，如本校不查致谢部分，建议从文档中删除后再提交检测。</div>
</div>;
const textwhy = <div className="numberBox">
    <div className="numberTitle"><i className="icon ills"></i>收稿日期</div>
    <div className="numberTitItem">为什么要设置收稿日期</div>
    <div className="numberItem">收稿日期是期刊编辑部通知作者论文被收录的日期，是已发表论文重要信息；通过设置送检文献收稿日期，可以限定比对数据范围，从而更精确地实现论文内容创新性检测。</div>
    <div className="numberTitItem">怎么选择和设置收稿日期？</div>
    <div className="numberItem">收稿日期一般在收录送检文献的期刊页面呈现，或作者自己提供；无收稿日期可使用论文发表时间；检测尚未公开发表的论文成果，可使用论文完成时间作为收稿日期。</div>
</div>;
const sid = getCookie('z_sid')
export default class checkFrom extends Component{
    constructor(){
        super();
        this.state={
            local:zhCN,
            info:50,
            num:0,
            valInfo:'',
            currentType:0,
            urlType:'',
            urlName:'',
            submitFlag:false,
            currPayType:0,
            returnImagesObj:{},
            returnCurrentCost:0,
            returnCostList:[],
            textLength:'',
            dateTime:'',
            uploadFlag:false,
            paperFlag:false
        }
    }
    // 论文类型切换
    onTypeCurrent=(current)=>{
        this.setState({
            currentType:current,
        })
        var params = {
            goodsType:this.state.urlType,
            checkType:this.state.currPayType,
            paperType:current
        }
        this.getReturnMoney(params);
        this.getRturnList(current)
    }
    // 计费方式切换
    onTypePayCurrent=(item)=>{
        if(item.costMap&&item.costMap.price!==-1){
            this.setState({
                currPayType:item.type
            })
            var params = {
                goodsType:this.state.urlType,
                checkType:item.type,
                paperType:this.state.currentType
            }
            this.getReturnMoney(params);
        }
    }
    // 切换计费方式获取价格
    getReturnMoney(params){
        React.$http.paperCheckGetUserPrice(params).then((res)=>{
            if(res&&res.success){
                this.setState({
                    textLength:res.validTextLength,
                    returnCurrentCost:res.currentCost,
                    returnCostList:res.checkTypeList,
                })
            }
        })
    }
    // 切换论文类型获取计费方式的数据
    getRturnList(current){
        let params = {
            paperType:current,
            goodsType:this.props.match.params.code,
        }
        React.$http.paperCheckGetGoodsTypeInfo(params).then((res)=>{
            if(res&&res.success){
                this.setState({
                    paperTypeList:res.paperTypeList,
                    returnCostList:res.checkTypeList
                })
            }
        })
    }
    onChange=(date, dateString)=>{
        this.setState({
            dateTime:dateString
        })
    }
    /* 提交并检测 */
    onSubmit=()=>{
        var paperTitle = this.refs.paperTitle.value;
        var paperAuthor = this.refs.paperAuthor.value;
        var params = {};
        if(paperTitle===''){
            messageTips('请输入论文标题！',1)
            return;
        }else if(paperTitle.length<5){
            messageTips('标题限制5-50个字，请重新输入论文标题!',1)
            return;
        }else if(paperAuthor===''){
            messageTips('请输入论文作者！',1)
            return;
        }
        if(this.state.currentType===1){
            if(this.state.dateTime===''){
                messageTips('请选择截稿日期！',1)
                return;
            }else{
                params = {
                    goodsType:this.state.urlType,//- 论文类型 本科 硕博等
                    paperType:this.state.currentType,// - 论文类型 默认0：新论文 1：已发表论文
                    checkType:this.state.currPayType,// - 查重类型 默认0：按字数检测 1：按篇检测
                    title:paperTitle,// - 标题
                    author:paperAuthor,// - 作者
                    publishDate:this.state.dateTime,// - 截稿日期
                }
            }
        }else{
            params = {
                goodsType:this.state.urlType,//- 论文类型 本科 硕博等
                paperType:this.state.currentType,// - 论文类型 默认0：新论文 1：已发表论文
                checkType:this.state.currPayType,// - 查重类型 默认0：按字数检测 1：按篇检测
                title:paperTitle,// - 标题
                author:paperAuthor,// - 作者
            }
        }
        React.$http.paperCheckAddPaperCheck(params).then((res)=>{
            if(res&&res.success){
                this.props.history.push('/order/detail/1/'+res.ser_id);
            }else{
                messageTips(res&&res.message,1)
                return
            }
        })
    }
    // 上传文件
    beforeUpload=(file)=> {
        const isLt2M = file.size / 1024 / 1024 < 30;
        const fileName = file.name.indexOf('_');
        this.setState({
            uploadFlag:true
        })
        if (!isLt2M) {
            // messageTips('图像必须小于30MB!',1);
            messageTips('上传的文件过大!',1);
            this.setState({
                uploadFlag:false
            })
            return;
        }
        if(fileName === -1){
            messageTips('请上传正确的文件格式名称!',1);
            this.setState({
                uploadFlag:false
            })
            return;
        }
        return isLt2M&&fileName;
    }
    handleChange = (info) => {
        const fileName = info.file.name.indexOf('_');
        if(fileName !== -1){
            if (info.file.status !== 'uploading') {
                const name = info.file.name;
                const nArr = name.split('.');
                const nameArr = nArr[0];
                const naArr = nameArr.split('_');
                if(naArr[0]===''){
                    messageTips('请上传正确的文件格式名称!',1);
                    this.setState({
                        uploadFlag:false
                    })
                    return;
                }else if(naArr[1]===''){
                    messageTips('请上传正确的文件格式名称!',1);
                    this.setState({
                        uploadFlag:false
                    })
                    return;
                }else{
                    if(info.file&&info.file.response&&info.file.response.success){
                        this.setState({                    
                            submitFlag:true,
                            uploadFlag:false,
                            returnImagesObj:info.file.originFileObj,
                            textLength:info.file.response.validTextLength,
                            returnCurrentCost:info.file.response.currentCost,
                            returnCostList:info.file.response.checkTypeList,
                        })
                    }else{
                        messageTips(info?(info.file?(info.file.response?info.file.response.message:'文件上传失败'):'文件上传失败'):'文件上传失败',1);
                        this.setState({
                            uploadFlag:false
                        })
                        return;
                    }
                }
            }
            if (info.file.status === 'done') {
                messageTips(`${info.file.name}文件上传成功！`,3);
                this.setState({
                    uploadFlag:false
                })
                return;
            } else if (info.file.status === 'error') {
                messageTips(`${info.file.name}文件上传失败！`,1);
                this.setState({
                    uploadFlag:false
                })
                return;
            }
        }
    }
    getCancel(){
        this.setState({
            submitFlag:false,
            returnImagesObj:{}
        })
    }
    getError=()=>{
        this.setState({
            loginFlag:false,
        })
    }
    getBlur(){
        let val = this.refs.paperTitle.value.trim();
        let lengths = val.length;
        if(lengths<5){
            messageTips('标题请控制在5-50个字之间!',1)
            return;
        }
    }
    getChangeText(){
        let val = this.refs.paperTitle.value.trim();
        let lengths = val.length;
		if(lengths<=this.state.info){
			this.setState({
                valInfo:val.substring(0,this.state.info),
				num:lengths,
            });	
        }
        if(this.refs.paperTitle.value.length>this.state.info){
            this.refs.paperTitle.value = this.state.valInfo
        }
    }
    componentDidMount(){
        document.onclick = this.getError;
        if(this.props.match.params.code==='04'){
            this.setState({
                // paperFlag:true,
                currentType:1
            })
        }
        this.setState({
            urlType:this.props.match.params.code,
            urlName:this.props.match.params.name,
        })
        this.getRturnList(this.state.currentType);
        document.documentElement.scrollTop=document.body.scrollTop=0;
        if(!sid){
            window.location.href = '/checkpaper.html'
        }
        
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }
    render(){
        const {
            local,
            currentType,
            urlType,
            urlName,
            submitFlag,
            currPayType,
            returnImagesObj,
            textLength,
            returnCurrentCost,
            returnCostList,
            paperTypeList,
            uploadFlag,
            num,
            info,
            paperFlag
        } = this.state;
        const imgprops = {
            name: 'file',
            data:{
                sid:sid,
                goodsType:urlType,
                checkType:currPayType,
                paperType:currentType
            },
            accept:'.doc,.docx,.pdf,.rtf,.txt',
            action: config.pathConUrl+config.urlMap.uploadPaperFile,
            headers: { authorization: 'authorization-text'},
            onChange: this.handleChange,
            beforeUpload:this.beforeUpload,
            showUploadList:false
        };
        return(
            <div className="containers">
                <Header></Header>
                <div className="mains padmain">
                    <div className="wrapmarg">
                        <div className="frombox fromMain">
                            <div className="from_tit">
                                <span className="from_text">
                                {urlName}
                                </span>
                            </div>
                            {
                                !paperFlag?(
                                    <div className="from_group frommag">
                                        <div className="group_label">论文类型</div>
                                        <div className="group_item">
                                        {
                                            paperTypeList&&paperTypeList.map((v,k)=>(
                                                <div className={`grouptab ${currentType===v.type?'curtab':''}`} onClick={()=>this.onTypeCurrent(v.type)} key={k}>{v.goods_name}<i className="icon richeck"></i></div>
                                            ))
                                        }
                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                ):''
                            }
                            
                            <div className="from_group fromgmar">
                                <div className="group_label">论文标题</div>
                                <div className="group_item">
                                    <input type="text" ref="paperTitle"
                                    // defaultValue={userInfo.presonalProfile} 
                                    // onFocus={this.getError.bind(this)}                                     
                                    onBlur={this.getBlur.bind(this)}                                     
                                    onChange={this.getChangeText.bind(this)}
                                    />
                                    <span className="postnum">{num}/{info}</span>
                                </div>
                                <div className="clear"></div>
                            </div>
                            <div className="from_group fromgmar">
                                <div className="group_label">论文作者</div>
                                <div className="group_item">
                                    <input type="text" ref="paperAuthor"/>
                                </div>
                                <div className="clear"></div>
                            </div>
                            <div className="from_group frommag">
                                <div className="group_label">上传文件</div>
                                <div className="group_items">
                                    <div className="group_items_load">
                                        <Upload {...imgprops}><div className="group_btn">选择文件</div></Upload>
                                        {/*uploadFlag?(<LoadingOutlined style={{color:'green',fontSize:'30px'}} />):''*/}
                                        {uploadFlag?(<span className="uploading"><Spin  />&nbsp;&nbsp;文件上传中</span>):''}
                                        <div className="group_items_paper">
                                            {returnImagesObj.name}{returnImagesObj.name?<span className="item_cancel" onClick={this.getCancel.bind(this)}>&times;</span>:''}
                                        </div> 
                                        <div className="clear"></div>
                                    </div>
                                    <div className="group_item_tit">上传须知：</div>
                                    <div className="group_item_p">
                                        <span>•</span>支持中文文献相似性检测
                                    </div>
                                    <div className="group_item_p">
                                        <span>•</span>支持上传.doc,.docx,.pdf,.rtf,.txt格式的文件
                                    </div>
                                    <div className="group_item_p">
                                        <span>•</span>文档大小不得超过30M,若超过30M导致上传失败，建议您删除送检文献中图片、图表、表格后，再上传
                                    </div>
                                    <div className="group_item_p">
                                        <span>•</span>论文文档命名格式：作者_标题 例：张三_关于加强发点企业内部控制的思考.doc
                                    </div>
                                </div>
                                <div className="clear"></div>
                            </div>
                            {
                                currentType===1?(
                                    <div className="from_group fromgmar" >
                                        <div className="group_label">收稿日期</div>
                                        <div className="group_item">
                                            <div className="itemTime">
                                                <i className="icon icon_time"></i>
                                                <ConfigProvider locale={local}>
                                                    <DatePicker placeholder={'请选择收稿日期'} onChange={this.onChange}></DatePicker>
                                                </ConfigProvider>
                                            </div>
                                            <div className="group_item_fonts">
                                                <Tooltip title={textwhy} placement="top">
                                                    <i className="icon icon_ill"></i>
                                                </Tooltip>
                                                为什么要设置收稿日期？
                                            </div>
                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                ):''
                            }
                            {
                                submitFlag?(
                                    <div className="from_group fromgmar">
                                        <div className="group_label">论文字数</div>
                                        <div className="group_item">
                                            <span className="group_item_font"><span className="paperSize">{textLength}</span>字</span>
                                            <span className="group_item_fonts">
                                                <Tooltip title={textNumber} placement="top">
                                                    <i className="icon icon_ill"></i>
                                                </Tooltip>
                                                字数计算说明
                                            </span>
                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                ):''
                            }
                            {
                                submitFlag?(
                                    <div className="from_group fromgmar">
                                        <div className="group_label">计费方式</div>
                                        <div className="group_item">
                                            {
                                                returnCostList&&returnCostList.map((v,k)=>(
                                                    <div className={`group_tab ${v.costMap.showPrice===-1?'dsbale':(currPayType===v.type?'curtab':'')}`} key={k} onClick={()=>this.onTypePayCurrent(v)}>
                                                        <i className="icon richeck"></i>{v.goods_name}支付<br/>
                                                        {
                                                            v.costMap.showPrice===-1?(
                                                                <span>暂不支持</span>
                                                            ):(
                                                                <span>¥{v.costMap.showPrice}元/{v.costMap.min_unit}</span>
                                                            )
                                                        }
                                                        
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                ):''
                            }
                            {
                                submitFlag!==false&&currPayType!==''?(
                                    <div className="from_group fromgmar">
                                        <div className="group_label">支付金额</div>
                                        <div className="group_item">
                                            <span className="group_item_font"><span className="papernum">¥{returnCurrentCost}</span></span>
                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                ):''
                            }
                            <div className="from_btn">
                                {
                                    submitFlag?(
                                        <span className="fmbtn" onClick={this.onSubmit}>支付并检测</span>
                                    ):('')
                                }
                            </div>
                            <div className="from_tit">
                                <span className="from_text">常见问题</span>
                            </div>
                            <div className="from-title">已发表论文如何检测？</div>
                            <div className="from-content">
                                <span className="from_index">【1】</span>
                                <div className="from_indent">万方系统具有已发表论文检测功能，上传word文档，命名格式：作者_标题。</div>
                                <div className="clear"></div>
                            </div>
                            <div className="from-content">
                                <span className="from_index">【2】</span>
                                <div className="from_indent">系统可自动排除本人文献的重合，并出具【辅助排除本人已发表文献相似比】，避免检测后，与自己发表过的论文相重复。</div>
                                <div className="clear"></div>
                            </div>
                            <div className="from-title">声明、目录、参考文献、致谢等内容是否进入查重范围？</div>
                            <div className="from-content">
                                <span className="from_index">【1】</span>
                                <div className="from_indent">格式规范的声明、目录、脚注、参考文献、致谢等内容，系统可智能识别。</div>
                                <div className="clear"></div>
                            </div>
                            <div className="from-content">
                                <span className="from_index">【2】</span>
                                <div className="from_indent">被识别后不会参与查重，万方系统仅依据其划分检测段落及判断引用情况。</div>
                                <div className="clear"></div>
                            </div>
                            <div className="from-content">
                                <span className="from_index">【3】</span>
                                <div className="from_indent">致谢部分，会作为正文参与查重，如本校不查致谢部分，建议从文档中删除后再提交检测。</div>
                                <div className="clear"></div>
                            </div>
                            <div className="from-title">系统的最小检测单位是句子吗？</div>
                            <div className="from-content">
                                <span className="from_index">【1】</span>
                                <div className="from_indent">万方已升级为2.0版本，语义级别检测技术已没有“最小检测单位”的概念；</div>
                                <div className="clear"></div>
                            </div>
                            <div className="from-content">
                                <span className="from_index">【2】</span>
                                <div className="from_indent">万方系统在识别重复和引用内容时，会结合上下文的内容，对达到一定的语义级别的内容进行判定，重合情况是由系统根据算法及指纹比对模型综合得出的；</div>
                                <div className="clear"></div>
                            </div>
                            <div className="from-content">
                                <span className="from_index">【3】</span>
                                <div className="from_indent">原样抄袭、改写、语句顺序调整等行为均能自动检测和识别，并标注显示。</div>
                                <div className="clear"></div>
                            </div>
                        </div>
                        <div className="frombox showMain">
                            <div className="from_tit">
                                <span className="from_text">检测须知</span>
                            </div>
                            <div className="from-titbox">比对库范围</div>
                            <div className="from-conbox">中国学术期刊数据库、中国学位论文全文数据库、中国学术会议论文数据库、中国学术网页数据库、中国专利文献数据库、中国优秀报纸数据库</div>
                            <div className="from-titbox">中文检测</div>
                            <div className="from-conbox">系统仅支持中文论文(包括简体、繁体)的检测，暂不支持英语等非中文论文的检测，请勿提交非中文论文！</div>
                            <div className="from-conbox">使用WPS软件的同学建议将文档转换成Word2003格式后再复制，以免复制不完整。</div>
                            {/* <div className="from-conbox">系统仅支持中文论文(包括简体、繁体)的检测，暂不支持英语等非中文论文的检测，请勿提交非中文论文！ 使用WPS软件的同学建议将文</div> */}
                            <div className="from-titbox">报告下载</div>
                            <div className="from-conbox">检测报告保留14天，请尽快下载报告到电脑永久保存</div>
                            <div className="from-bor">
                                <a href="http://chat10.live800.com/live800/chatClient/chatbox.jsp?companyID=448316&jid=6318557147&enterurl=http%3A%2F%2Fwww%2Eepsnet%2Ecom%2Ecn%2Fch%2FSys%2FReportPage%2Easpx%3FKey%3D230%26Type%3DKE%5FCLASS%5FEXPRESSREPORT&timestamp=1344843114447&pagereferrer=" target="_blank" rel="noopener noreferrer">
                                    <div className="from-left">
                                        <i className="icon icon_kefu"></i>
                                    </div>
                                    <div className="from-rig">
                                        <div className="from-rigtit">在线咨询</div>
                                        <div className="from-rigtime">服务时间：9:00-18:00</div>
                                    </div>
                                </a>
                                <div className="clear"></div>
                            </div>
                        </div>
                        <div className="clear"></div>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        )
    }
}
